import React, { ReactElement } from "react";
import ReportsDropdown from "../../../components/ReportsDropdown";
import AlertsLogLink from "../../../components/AlertsLogLink";

export interface VisReport {
  name: string;
  link: string;
}

export interface ReportsAlertsHeaderProps {
  reports: VisReport[];
  saveReportsHandler: (reports: VisReport[]) => Promise<void>;
  generalReportParamsIds: number[];
}

export default function ReportsAlertsHeader({
  reports,
  saveReportsHandler,
  generalReportParamsIds,
}: ReportsAlertsHeaderProps): ReactElement {
  return (
    <div
      className="reports-container d-flex justify-content-between align-items-center"
      style={{ marginBottom: "15px" }}
    >
      <ReportsDropdown
        reports={reports}
        saveReportsHandler={saveReportsHandler}
        generalReportParamsIds={generalReportParamsIds}
      />
      <div>
        <AlertsLogLink />
      </div>
    </div>
  );
}
